<template>
  <div
    class="quizCard"
    :class="info.stype === 1 ? 'card-allTeams' : 'card-normal'"
    :data-type="info.type"
    :data-odds="info.odds"
    :data-choosenum="info.choose_num"
  >
    <div class="header">
      <div class="right">
        <div v-if="lg(info, 'answers', []).length === 0" class="question">
          <i class="title-icon" v-if="info.stype === 1"></i>
          <UiLabel :shadow-color="labelColors.shadow" :text-color="labelColors.text">
            {{ title }}
          </UiLabel>
        </div>
        <div v-else class="answer">
          <UiLabel :shadow-color="labelColors.shadow" :text-color="labelColors.text">
            竞猜结果：{{ lg(info, "answers", []).map(a => a?.answer).filter(Boolean).join(',') }}
          </UiLabel>
        </div>
      </div>
      <div class="time" v-if="info.stype !== 1 && (info.startAt || info.endAt)">
        <UiLabel shadow-color="transparent" text-color="#FFFFFF">
          开始时间: {{ formatTime(info.startAt) }}
        </UiLabel>
        <UiLabel shadow-color="transparent" text-color="#FFFFFF">
          结束时间: {{ formatTime(info.endAt) }}
        </UiLabel>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import lg from '@/utils/lg'
import { computed } from "vue";
import UiLabel from "@/components/ui-label";

const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  }
});

const title = computed(() => {
  return props.info.title || '赛程竞猜'
});

function formatTime(val) {
  if (!val) return '-'
  const date = new Date(val)
  const hour = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  return `${hour}:${min}`
}
// stype=1 (card-allTeams) / else (card-normal) 两套 label 描边+主字色
const labelColors = computed(() => {
  if (props.info.stype === 1) {
    return { shadow: '#880000', text: '#FFF' }
  }
  return { shadow: 'transparent', text: '#6D0402' }
});
</script>

<style lang="scss" scoped>

.quizCard {
  position: relative;
  margin-bottom: get_vw(16);
  overflow: hidden;

  .header {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .time {
      position: absolute;
      left: 32%;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      font-size: get_vw(16);
      white-space: nowrap;
      // 第二个及以后 label 加左间距
      > :nth-child(n+2) {
        margin-left: get_vw(14);
      }
    }

    .right {
      color: $yellow;
      margin-right: get_vw(40);
      display: flex;

      .answer-btn {
        width: get_vw(128);
        height: get_vw(34);
        line-height: get_vw(36);
        background-color: $yellow;
        border-radius: get_vw(8);
        text-align: center;
        font-size: get_vw(20);
        color: #111;
        cursor: pointer;
      }
    }
  }

  &.card-normal {
    background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QZEAO6rp.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .header {
      height: get_vw(49);
      padding-left: get_vw(17);
      box-sizing: border-box;
      .right {
        font-size: get_vw(20);
      }
    }
  }

  &.card-allTeams {
    // 说是默认只有一个赛程竞猜，先把底部margin去掉了
    width: get_vw(1384);
    margin: 0 auto;
    .header {
      height: get_vw(56);
      // align-items: flex-start;
      .right {
        font-size: get_vw(24);
      }
    }

    .question {
      display: flex;
      align-items: center;
      .title-icon {
        display: inline-block;
        height: get_vw(36);
        width: get_vw(36);
        margin-right: get_vw(16);
        @include icon_status('quiz_1');
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
